import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Founder Card - fade in with image zoom
 */
export const animateFounderCard = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const image = element.querySelector('img');
    const content = element.querySelector('[class*="textContent"]');
    
    // Set initial state immediately to prevent flash
    if (image) {
      gsap.set(image, { scale: 0.8, opacity: 0 });
    }
    if (content) {
      gsap.set(content, { opacity: 0, y: 30 });
    }
    
    const timer = setTimeout(() => {
      if (image) {
        gsap.to(image, {
          scale: 1,
          opacity: 1,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      
      if (content) {
        gsap.to(content, {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

